import { isNil } from "@etudescarre/utils";
import { useCallback } from "react";
import { useParams } from "react-router";
import { toaster } from "@/app";
import { apiClient } from "@/lib/api/client";

/** Opens a file of the yard in the browser's viewer. */
export function useOpenFichier() {
  const { yardId } = useParams<{ yardId: string }>();

  return useCallback(
    async (fichierId: number) => {
      const { data } = await apiClient.GET(
        "/api/yards/{yardId}/fichiers/{fichierId}/url",
        {
          params: {
            path: { yardId: yardId ?? "", fichierId: String(fichierId) },
          },
        },
      );
      if (isNil(data)) {
        toaster.error({
          title: "Fichier indisponible",
          description: "Le fichier n'a pas pu être ouvert, réessayez",
        });
        return;
      }
      window.open(data.data.inlineUrl, "_blank", "noopener,noreferrer");
    },
    [yardId],
  );
}
